module.exports = __webpack_public_path__ + "img/noaddlist.a17fe3af.png";